import React from 'react';

export const HeaderStyleForGrommet = {
    gridArea: "header",
    background: "white",
    // background: {
    //     // color: "white",
    //     dark: "true"
    // },
    height: "50px"
}

export const HeaderStyle = {
    style: {
        marginTop: '0px',
        marginBottom: '0px'
    }
}

export const HeaderSpanStyle: React.HTMLAttributes<HTMLSpanElement> = {
    style: {
        borderBottomColor: "#005bac",
        borderBottomStyle: "solid",
    }
}

export const MainStyleForGrommet = {
    gridArea: "main",
    background: "#ffffff"
}

export const CheckboxStyleByGrom = {
    style: {
        borderBottomColor: "#005bac",
        borderBottomStyle: "solid",
    }
}

export const AccordionBoxStyle = {
    background: "#005bac"
}

export const AccordionPanelBoxStyle = {
    background: "white"
}

export const AccordionPaneStyle = {
    background: "white"
}

export const LoginLogStyle = {
    marginTop: "4px"
}

export const theme = {
    global: {
        colors: {
            brand: "#005bac"
        },
        font: {
            size: "15px"
        },
        breakpoints: {
            small: {
                value: 970
            }
        }
    },
    checkBox: {
        border: {
            color: "#005bac"
        },
        extend: {
            margin: "1px",
            marginTop: "7px"
        }
    },
    textInput: {
        extend: {
            marginTop: "4px",
            marginBottom: "2px",
            paddingTop: "3px",
            paddingBottom: "7px"
        },
    },
    button: {
        extend: {
            marginTop: "4px",
            marginRight: "2px",
            marginLeft: "2px",
            paddingTop: "2px",
            paddingBottom: "2px"
        }
    },
    select: {
        extend: {
            marginTop: "2px",
            marginBottom: "0px",
            paddingTop: "0px",
            paddingBottom: "1px",
        }
    },
    textArea: {
        extend: {
            height: "80px"
        }
    }
}

export const TextInputStyle = {
    style: {
        paddingTop: "0px",
        paddingBottom: "0px"
    }
}

export const SelectStyle = {
    style: {
        paddingTop: "0px",
        paddingBottom: "1px"
    }
}
